export const UNSUBSCRIBE_ROUTE_NAME = Symbol('shared.unsubscribe');
export const TRANSLATION_GROUP_UNSUBSCRIBE = Symbol('unsubscribe');

export const UNSUBSCRIBE_CHECK_STATUS_URL = 'anonym/unsubscribes/:token/check';
export const UNSUBSCRIBE_DO_UNSUBSCRIBE_URL = 'anonym/unsubscribes/:token/unsubscribe';

export const UNSUBSCRIBE_CHECK_STATUS_QUERY_KEY = 'unsubscribe.check-status';
export const UNSUBSCRIBE_DO_UNSUBSCRIBE_QUERY_KEY = 'unsubscribe.opt-out';
